export default __webpack_public_path__ + "static/media/legend_short.bb40bec8.png";